import React, {
  useState,
  useEffect,
  useRef,
  useLayoutEffect,
  useImperativeHandle,
  forwardRef,
} from 'react'
import { useSelector, useDispatch } from 'react-redux'
import MD5 from 'js-md5'
import styles from './AIPCZX.module.css'
import { Affix, Anchor, Button, Flex, message, Modal } from 'antd'
import HeaderBar from './HeaderBar'
import ListItem from './ListItem'
import {
  cancelCollectCardRequest,
  collectCardRequest,
  getCardInfoListRequest,
  updateAppLogRequest,
} from './AIPCZXApi'
import bannerImg from './banner.jpg'
import CommentInfoDrawer from './CommentInfoDrawer'
import { setShowPlayerModalStatus, setVideoId } from '../../PlayerModal/PlayerModalSlice'

// export default function AIPCZX(props) {

const AIPCZX = forwardRef((props, ref) => {
  //   const count = useSelector(selectCount);
  const dispatch = useDispatch()
  const [messageApi, contextHolder] = message.useMessage()
  const [searchStr, setSearchStr] = useState('')
  const [appCardList, setAppCardList] = useState([])

  const [zpCardWidth, setZpCardWidth] = useState(window.innerWidth - 240 - 98)
  const [drawerStatus, setDrawerStatus] = useState(false)
  const [drawerInfo, setDrawerInfo] = useState({})

  // const incrementValue = Number(incrementAmount) || 0;

  useEffect(() => {
    // 在这里执行你的组件挂载后的逻辑
    // 这里可以返回一个清理函数，它会在组件卸载前执行
    getCardInfoList('')
    window.addEventListener('resize', handleResize)
    return () => {
      window.removeEventListener('resize', handleResize)
      // console.log('组件即将卸载');
    }
  }, []) // 空数组意味着这个 effect 只会在组件挂载时执行一次

  useLayoutEffect(() => {}, [])
  const wdzpListRef = useRef(null)

  function handleResize() {
    if (wdzpListRef.current) {
      const width = wdzpListRef.current.offsetWidth
      setZpCardWidth(width)
    }
  }

  function getCardInfoList(nameKey) {
    getCardInfoListRequest(nameKey, (data) => {
      if (data.ret == 1) {
        setAppCardList(data.data.waibuyingyong_arr)
      } else {
        setAppCardList([])
        messageApi.open({
          type: 'warning',
          content: data.msg,
        })
      }
    })
  }

  function createBotMethod(params) {
    props.jumpToCreateBot(31)
  }

  function selectItem(params) {
    if (params.link_url.includes('http')) {
      updateAppLogRequest(params, (data) => {
        if (data.ret == 1) {
          window.open(params.link_url)
        } else {
          message.info(data.msg)
        }
      })
    } else {
      message.info('请配置应用链接')
    }
  }

  function collectMethod(params) {
    if (params.shoucang_status == 0) {
      collectCardRequest(params.code, (data) => {
        if (data.ret == 1) {
          console.log(searchStr)
          getCardInfoList(searchStr)
        } else {
          messageApi.info(data.msg)
        }
      })
    } else {
      cancelCollectCardRequest(params.code, (data) => {
        if (data.ret == 1) {
          getCardInfoList(searchStr)
        } else {
          messageApi.info(data.msg)
        }
      })
    }
  }

  function playVideo(videoUrl) {
    dispatch(setShowPlayerModalStatus(true))
    dispatch(setVideoId(videoUrl))
  }
  function openDrawer(info) {
    setDrawerStatus(true)
    setDrawerInfo(info)
  }
  return (
    <div className={styles.background} id={'rightContentAnchor'}>
      {contextHolder}
      <div className={styles.topContainer}>
        <HeaderBar
          createBot={createBotMethod}
          // confirmSearch={(e) => {
          //     getCardInfoList(e)
          //     setSearchStr(e)
          // }}

          confirmSearch={(value) => {
            props.globalSearch(value, 2)
          }}
        />
        <img className={styles.bannerImg} src={bannerImg} />
      </div>
      <h3 style={{ marginLeft: 60 }}>AI评测中心</h3>
      <div className={styles.itemContainer} ref={wdzpListRef}>
        {appCardList.map((item, index) => {
          return (
            <ListItem
              info={item}
              boxWidth={zpCardWidth}
              clickMethod={selectItem}
              collectMethod={collectMethod}
              playVideo={playVideo}
              openDrawer={openDrawer}
            />
          )
        })}
      </div>
      <CommentInfoDrawer
        info={drawerInfo}
        drawerStatus={drawerStatus}
        close={() => {
          setDrawerStatus(false)
        }}
        refreshMethod={getCardInfoList.bind(null, searchStr)}
      />
    </div>
  )
})
export default AIPCZX
